export type CloudSnapshot = Record<string, unknown>;

const parseRevision = (response: Response) =>
  response.headers.get("ETag")?.replace(/^"|"$/g, "") ?? "0";

export class CloudSyncClient {
  revision = "0";

  constructor(
    private readonly fetchFn: typeof fetch = window.fetch.bind(window),
  ) {}

  async load(): Promise<CloudSnapshot | null> {
    const response = await this.fetchFn("/api/snapshot", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) {
      throw new Error(`Cloud sync load failed (${response.status})`);
    }
    this.revision = parseRevision(response);
    if (response.status === 204) {
      return null;
    }
    return (await response.json()) as CloudSnapshot;
  }

  async save(snapshot: CloudSnapshot) {
    const response = await this.fetchFn("/api/snapshot", {
      method: "PUT",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "If-Match": `"${this.revision}"`,
      },
      body: JSON.stringify(snapshot),
    });
    const revision = parseRevision(response);
    if (response.status === 409) {
      this.revision = revision;
      return { status: "conflict" as const, revision };
    }
    if (!response.ok) {
      throw new Error(`Cloud sync save failed (${response.status})`);
    }
    this.revision = revision;
    return { status: "saved" as const, revision };
  }
}
